import includes from 'lodash/includes'
import React from 'react'
import { useHistory, useUser } from '@ztechapps/common.hook'
import { CenterScreen } from '@ztechapps/webui.util'
import { routesDef } from '../../../config/routes'
import { paymePermissions } from '@ztechapps/totalmilk-payme.common'
import {
  AccountJoinLoading,
  AccountJoinPending,
  AccountJoinInActive,
  AccountJoin,
  AccountJoinProvider,
} from '@ztechapps/webui.auth'
import { LogoWithName } from '../../../components/logo/LogoWithName'

export default function JoinPage() {
  const { user, loggedIn, isPending, hasTenant, isInActive, loading } = useUser()
  const history = useHistory()

  const roles = user?.roles
  const [render, setRender] = React.useState(<AccountJoinLoading />)

  React.useEffect(() => {
    if (loading) return
    if (!loggedIn) {
      history.push(routesDef.LoginPage.altPath)
    }

    //has storeBack.canAccess role
    const hasAppAccess = includes(roles, paymePermissions.app.canAccess.value)

    if (!hasTenant) setRender(<AccountJoin />)
    else if (isPending || !hasAppAccess) setRender(<AccountJoinPending />)
    else if (isInActive) setRender(<AccountJoinInActive user={user} />)
    else {
      history.push(routesDef.OverviewPage.path)
    }
  }, [loading, loggedIn, hasTenant, isPending, isInActive, roles, history, user])

  return (
    <CenterScreen>
      <AccountJoinProvider logo={<LogoWithName />}>
        <div style={{ minHeight: 400 }}>{render}</div>
      </AccountJoinProvider>
    </CenterScreen>
  )
}
